import { WitaConnector } from '@/services/repository/connector'
import { querySerializer } from '@/utils/helpers/URLs'

import { Repo } from './Asset.d'

const ROOT_URL = '/entity/assets'

export const AssetRepository = {
  Search: async (params: Repo.Asset.Search.Params) => {
    const url = ROOT_URL + `?${querySerializer(params)}`
    return await WitaConnector.get<Repo.Asset.Search.Response>(url)
  },

  FindById: async ({ id }: Repo.Asset.FindById.Params) => {
    const url = ROOT_URL + `/${id}`
    return await WitaConnector.get<Repo.Asset.FindById.Response>(url)
  },

  ConsumptionReport: async ({
    id,
    ...params
  }: Repo.Asset.ConsumptionReport.Params) => {
    const url =
      ROOT_URL + `/${id}/consumption-report?${querySerializer(params)}`
    return await WitaConnector.get<Repo.Asset.ConsumptionReport.Response>(url)
  },

  Create: async (params: Repo.Asset.Create.Params) => {
    const url = ROOT_URL
    return await WitaConnector.post<Repo.Asset.Create.Response>(url, params)
  },

  Edit: async ({ id, ...params }: Repo.Asset.Edit.Params) => {
    const url = ROOT_URL + `/${id}`
    return await WitaConnector.put<Repo.Asset.Edit.Response>(url, params)
  },
}
